import React from "react";
import KrogerBannerImage from "../../images/Google-Home.svg";
import { Link } from "gatsby";
import { motion } from 'framer-motion';

export default function KrogerMainBanner() {

  const variants = {
    hidden: {
      //scale: 0,
      opacity: 0,
      x: 300
    },
    show: {
      //scale: 1,
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.7
      }
    }
  };

  return (
    <div className="cs-page-main-banner-section section-gap">
      <div className="cs-banner-image d-flex align-end justify-center">
        <motion.div
          initial="hidden"
          animate="show"
          variants={variants}
          className="container d-flex flex-wrap align-start justify-center">
          <img src={KrogerBannerImage} alt="online voice shopping experience" title="Voice Shopping Platform" />
        </motion.div>
      </div>
      <div className="cs-main-banner-detail">
        <div className="container">
          <div className="row d-flex flex-wrap row-banner-title">
            <div className="col left-bar">
              <h1>Grocery shopping with your voice-assistant </h1>
            </div>
            <div className="col right-bar">
              <h3>How we helped a US retail giant deliver hands-free shopping experiences? </h3>
            </div>
          </div>
          <div className="row d-flex flex-wrap align-v-center">
            <div className="col left-bar">
            <p>Strategy · Transformation · Engineering · Innovation</p>
            </div>
            <div className="col right-bar">
              {/*<Link className="button button-xsmall button-white-border" to="/contact/">Let's Chat</Link>*/}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}